import React from "react";

const InputField = ({
    value,
    label,
    input_name,
    placeholder,
    type,
    onChange,
    input_class,
    required,
    children
}) => (
    <div className="form-group mt-3">
        {label && <label htmlFor="input-field">{label}</label>}
        {children}
        <input
            name={input_name}
            type={type}
            value={value}
            onChange={onChange}
            required={required}
            className={input_class}
            placeholder={placeholder}
        />
    </div>
);

export default InputField;